import { Table, Button, Space, Card, message, Skeleton, Col, Row } from 'antd';
import { scanmaster, scriptitem } from '../typing/table_typing';
import { Component } from 'react';
import { cardmargin, grayheader } from '../../CSSReferences';
import { UserOutlined } from '@ant-design/icons';

export interface TableThingyMainProps{
  model:scriptitem[],
  view:{
    loaded: boolean, 
    autorefresh: boolean,
  }
  scanmasterlist:string,//scanmaster[],
  onLoadRequested:()=>void;
  onDeleteRequested:(item:string)=>void;
}

interface TableThinyViewInnerState{
      filteredInfo:any, 
      sortedInfo:any,   
      visible: boolean,
      condition: boolean,
      itemToDelete:string, 
      scanmaster:string, 
      parameterlist:string
    }


export class ScriptThingyView extends Component<TableThingyMainProps, TableThinyViewInnerState> 
{
    constructor(props:TableThingyMainProps){
      super(props);
       this.state = {
         filteredInfo: null,
         sortedInfo: null,
          visible: true,// data.user.map((x:userdata) => {return false}),
          scanmaster: '',//user.map((x:userdata) => {return "x"}),
          parameterlist: '',
          condition:false,
          itemToDelete:''
     }
    }

    componentWillReceiveProps(){
    this.setState({
      // visible: this.props.data.user.map((x:userdata) => {return false}),
      // scanmaster: this.props.data.user.map((x:userdata) => {return "x"}),
      // // if thiny != x do not touch
      // parameterlist: this.props.data.user.map((x:userdata) => {
      //   return {
      //     startdate : "",
      //     interval : 28,
      //     status : "",
      //     tags : "",
      //     targettype : "",
      //     credentialsgroup: "",
      //   }
      // }),
    })
  }
  

    componentDidMount(){
       setTimeout(() => {
        //setInterval(() => {
         // console.log(Date.now());
        this.props.onLoadRequested()
      }, 400);
      
      // this.props.onButtonClicked();
    }

    OnDeleteButtonPressed(item:string){
      console.log(item +"will be deleted")
      this.props.onDeleteRequested(item)
    }
   
    handleChange = (pagination:any, filters:any, sorter:any) => {
        this.setState({
          filteredInfo: filters,
          sortedInfo: sorter,
        });
      };
    

  handleVisibleChange = (visible:any, clickedElementIndex:number, uuid:string) => {
    // if (!visible) {
    //   this.setState({  visible:this.state.visible.map((elem:boolean, index:number) =>{
    //     return index===clickedElementIndex? !this.state.visible[index]:this.state.visible[index]
    //   } )  });
    //   return;
    // }
    // // Determining condition before show the popconfirm.
    // if (this.state.condition) {
    //   this.confirm(clickedElementIndex, uuid); // next step
    // } else {
    //   this.setState({ visible:this.state.visible.map((elem:boolean, index:number) =>{
    //     return index===clickedElementIndex? !this.state.visible[index]:this.state.visible[index]
    //   } )  }); // show the popconfirm
    // }
  };

  changeCondition = (value:any) => {
    this.setState({ condition: value });
  };

  private _scan = (targetuuid: string, targetIP: string, scanmasteruuid: string, scanmastername: string) => {
    if (scanmasteruuid === "x") {
      message.error(targetIP + " has no Scan defined");
    }

    else {
      message.success(targetIP + " will be scanned " + this.showScanname(scanmasteruuid));
    }
  };
  public get scan_1() {
    return this._scan;
  }
  public set scan_1(value) {
    this._scan = value;
  }
  public get scan() {
    return this._scan;
  }
  public set scan(value) {
    this._scan = value;
  }

  setScanState = (clickedElementIndex:number, uuid:string) => {
    console.log(clickedElementIndex, uuid)
    // this.setState({ scanmaster:this.state.scanmaster.map((elem:string, index:number) =>{
    //   return index===clickedElementIndex? uuid : this.state.scanmaster[index]
    //   } ) });
  }

  showScanname =(input:string) =>
  {
    // var item = this.props.scanmasterlist.find(myObj => myObj.uuid===input);
    // if (item !== undefined)
    // {
    //   return item.description
    // }
    // else
    // {
    //   return "None"
    // }
  }

  confirm = (clickedElementIndex:number, uuid:string) => {
    // this.setState({ visible:this.state.visible.map((elem:boolean, index:number) =>{
    //   return index===clickedElementIndex? !this.state.visible[index]:this.state.visible[index]
    // } ) });
    // message.success(uuid +" will be deleted");
    // this.props.onDeleteRequested(uuid)
  };

  cancel = (clickedElementIndex:number) => {
    // this.setState({ visible:this.state.visible.map((elem:boolean, index:number) =>{
    //   return index===clickedElementIndex? !this.state.visible[index]:this.state.visible[index]
    // } )  });
    // message.error('Click on cancel.');
  };

      clearFilters = () => {
        this.setState({
        filteredInfo: null,
      });
      };
    
      clearAll = () => {
        this.setState({
          filteredInfo: null,
          sortedInfo: null,
        });
      };
    
      setAgeSort = () => {
        this.setState({
          sortedInfo: { 
            order: 'descend',
            columnKey: 'ipv4',
          },
        });
      };
    
      handleMenuClick(e:any) {
        // message.info('Click on menu item.', e);
        // console.log('click', e);
      }


      /**
       * Die Eintraege der Auswahl - als Daten, wie antd 6 sie erwartet.
       *
       * Der zugehoerige <Dropdown> fehlt in dieser Ansicht; die Liste wird
       * derzeit nirgends angezeigt. Mitgezogen, damit sie beim Wiederbeleben
       * nicht in einer abgekuendigten Form dasteht. Der <Button> um jeden
       * Eintrag entfaellt - er trug nur den onClick.
       */
      getScanmaster(scanmaster:scanmaster[], recordID:number){
        let returnvalue: any[] = []
        returnvalue.push({
          key: recordID + 'x',
          icon: <UserOutlined />,
          label: "None",
          onClick: () => { this.setScanState(recordID, 'x') },
        })
        for (let item in scanmaster)
        {
          returnvalue.push({
            key: recordID + scanmaster[item].uuid,
            icon: <UserOutlined />,
            label: scanmaster[item].description,
            onClick: () => { this.setScanState(recordID, scanmaster[item].uuid) },
          })
        }
        return returnvalue;
      }

render(){
  console.log(this.state);
  let { sortedInfo, filteredInfo } = this.state;
    sortedInfo = sortedInfo || {};
    filteredInfo = filteredInfo || {};
    
    const columns = [
      {
        title: 'UUID',
        dataIndex: 'uuid',
        key: 'uuid',
        filters: [
        ],
        filteredValue: filteredInfo.name || null,
        onFilter: (value:any, record:any) => record.ipv4.includes(value),
        sorter: (a:any, b:any) => a.uuid.length - b.uuid.length,
        sortOrder: sortedInfo.columnKey === 'uuid' && sortedInfo.order,
        ellipsis: false,
      },
      {
        title: 'Software',
        dataIndex: 'software',
        key: 'software',
        sorter: (a:any, b:any) => a.software.name- b.software.name,
        sortOrder: sortedInfo.columnKey === 'software.name' && sortedInfo.order,
        ellipsis: false,
      },
      {
        title: 'Version',
        dataIndex: 'version',
        key: 'version',
        render: (tags:any) => (
          <span>            
           { tags}
          </span>
        ),
        filters:[
          { text: 'System', value: 'System' },
          { text: 'User', value: 'User' },
        ],
        filteredValue: filteredInfo.version || null,
        onFilter: (value:any, record:any) => record.version.includes(value),
        sorter: (a:any, b:any) => a.version.length - b.version.length,
        sortOrder: sortedInfo.columnKey === 'version' && sortedInfo.order,
        ellipsis: false,
      },
      {
        title: 'Branch',
        dataIndex: 'branch',
        key: 'branch',
        sorter: (a:any, b:any) => a.branch.length- b.branch.length,
        sortOrder: sortedInfo.branch === 'uid' && sortedInfo.order,
        ellipsis: false,
      },
      {
        title: 'Exec',
        dataIndex: 'exec',
        key: 'exec',
        sorter: (a:any, b:any) => a.exec.length- b.exec.length,
        sortOrder: sortedInfo.exec === 'uid' && sortedInfo.order,
        ellipsis: false,
      },
      {
        title: 'Identifier',
        dataIndex: 'identifier',
        key: 'identifier',
        sorter: (a:any, b:any) => a.branch.length- b.branch.length,
        sortOrder: sortedInfo.branch === 'uid' && sortedInfo.order,
        ellipsis: false,
      },
      {
        title: 'Action',
        key: 'action',
        render: (text:any, record:any) =>{
          // const recordID = this.props.data.user.findIndex((x:userdata) => {
          //   return x.uuid===record.uuid
          // })
          return(
                 <Button onClick={() => {this.OnDeleteButtonPressed(text.uuid.substring(0,36))}}> x </Button>
          );
        },
      },
    ];

    

    if (this.props.view.loaded === false)
    {
      return (
        <div>
          <Card title="Script vault" style={cardmargin}  hoverable styles={{ header: grayheader }}>
          <Skeleton active />
          </Card>
          </div>
      )    
    }
    else
    {
  return (
    <div>
       <Card title={"Script vault"} style={cardmargin} hoverable styles={{ header: grayheader }}>
    <Space style={{ marginBottom: 16 }}>
      <Row gutter={16}>

        <Col span={24}>
         
        </Col>
      </Row>
    </Space>
    <Table pagination={{position: ['topCenter', 'bottomCenter'] }} columns={columns} dataSource={this.props.model} onChange={this.handleChange} /> 
    </Card> 
    </div>
  )}
}
}